<template>
  <div>
    <b-modal
      title="Achtung: unabgespeicherte Daten"
      v-model="modalCloseDialogueState"
      centered
      ><!-- modal -->
      <div>
        <p>
          Sie haben MailTemplateänderungen vorgenommen, aber nicht
          abgespeichert. Sind Sie sich sicher, dass sie das Edit-Fenster
          schliessen wollen?
        </p>
      </div>
      <template #modal-footer>
        <div class="w-100">
					<b-button
							size="md"
							class="float-right"
							variant="danger"
							@click="modalCloseDialogue('confirm')"
					>
						schliessen
					</b-button>
          <b-button
            size="md"
            class="float-right mx-1"
            @click="modalCloseDialogue('abort')"
          >
            abbrechen
          </b-button>
        </div>
      </template>
    </b-modal>
    <b-modal
      title="Mail Template Löschen"
      v-model="modalDeleteDialogueState"
      centered
      ><!-- modal -->
      <b-overlay :show="queryInProgress" rounded="sm">
        <p>Sind Sie sich sicher, dass sie das Template löschen wollen?</p>
      </b-overlay>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            size="md"
            class="float-right mx-1"
            variant="danger"
            @click="remove()"
          >
            löschen
          </b-button>
          <b-button
            size="md"
            class="float-right"
            @click="modalDeleteDialogueState = false"
          >
            abbrechen
          </b-button>
        </div>
      </template>
    </b-modal>
    <b-modal
      title="Mail-Template Speichern"
      v-model="modalSuccessDialogue"
      centered
      ><!-- modal -->
      <div>
        <p>Das Mail-Template wurde erfolgreich abgespeichert.</p>
      </div>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            size="md"
            class="float-right mx-1"
            variant="success"
            @click="
              modalEdit.visible = false;
              modalEdit.oldMailTemplate = null;
              openChanges = false;
              modalSuccessDialogue = false;
            "
          >
            schliessen
          </b-button>
        </div>
      </template>
    </b-modal>
    <b-overlay
      :show="queryInProgress && !modalDeleteDialogueState"
      rounded="sm"
    >
      <b-card>
        <div class="row" id="coi-pagination">
          <div class="col-md-4">
            <div class="d-flex justify-content-start">
              <h3>Mail Template</h3>
            </div>
          </div>
          <div class="col-md-8">
            <div class="d-flex flex-row justify-content-end">
              <div class="d-flex flex-row-reverse">
                <div class="pl-2 py-2">
                  <b-button size="md" @click="createTemplate()"
                    >Template hinzufügen</b-button
                  >
                </div>
                <div class="py-2">
                  <b-form-select
                    id="per-page-select"
                    v-model="perPage"
                    :options="pageOptions"
                    size="md"
                  ></b-form-select>
                </div>
                <div class="p-2">
                  <b-pagination
                    id="table-pagination-mail-template"
                    class="float-right"
                    v-if="items"
                    v-model="currentPage"
                    :total-rows="items.length"
                    :per-page="perPage"
                    aria-controls="table-mail-template"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>

        <b-table
          id="table-mail-template"
          :items="items"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
          small
        >
          <template #cell(label)="row">
            <span v-if="'isDeleted' in row.item" class="strikethrough">{{
              row.item.label
            }}</span>
            <span v-else-if="'isCreated' in row.item" class="new-element">{{
              row.item.label
            }}</span>
            <a v-else @click="edit(row.item.id)" class="link2">{{
              row.item.label
            }}</a>
          </template>

          <template #cell(mailTemplateType)="row">
            <span v-if="'isDeleted' in row.item" class="strikethrough">{{
              getTypeLabel(row.item.mailTemplateType)
            }}</span>
            <span v-else-if="'isCreated' in row.item" class="new-element">{{
              getTypeLabel(row.item.mailTemplateType)
            }}</span>
            <span v-else>{{ getTypeLabel(row.item.mailTemplateType) }}</span>
          </template>
          <template #cell(marketAccountId)="row">
            <span v-if="'isDeleted' in row.item" class="strikethrough">{{
              marketAccounts.find((x) => x.id === row.item.marketAccountId).name
            }}</span>
            <span v-else-if="'isCreated' in row.item" class="new-element">{{
              marketAccounts.find((x) => x.id === row.item.marketAccountId).name
            }}</span>
            <span v-else>{{
              marketAccounts.find((x) => x.id === row.item.marketAccountId).name
            }}</span>
          </template>
          <template #cell(mailAddressId)="row">
            <span v-if="'isDeleted' in row.item" class="strikethrough">
              {{
                mailTemplateShippers.find(
                  (x) => x.id === row.item.mailAddressId,
                ).email
              }}</span
            >
            <span v-else-if="'isCreated' in row.item" class="new-element">
              {{
                mailTemplateShippers.find(
                  (x) => x.id === row.item.mailAddressId,
                ).email
              }}</span
            >
            <span v-else
              >{{
                mailTemplateShippers.find(
                  (x) => x.id === row.item.mailAddressId,
                )?.email
              }}
            </span>
          </template>

          <template #cell(action)="row">
            <!-- b-button
                     @click="edit(row.item.id)"
                     size="sm"
                     variant="primary"
               >✎</b-button-->
            <b-button
              v-if="!('isDeleted' in row.item)"
              @click="openDeleteDialogue(row.item)"
              size="sm"
              variant="outline-danger"
              class="pt-1 pb-0 px-1"
              ><span class="icon icon-bin" style="font-size: 1.25em"
            /></b-button>
          </template>
        </b-table>
        <b-modal
          id="modal-mail-template"
          v-model="modalEdit.visible"
          size="xl"
          title="Mail-Template bearbeiten"
          centered
          no-close-on-esc
          no-close-on-backdrop
          hide-header-close
          ><!-- modal -->
          <b-alert :show="openChanges" variant="warning"
            >Sie haben unabgespeicherte Änderungen offen.</b-alert
          >
          <form class="pr-5" v-if="newMailTemplate">
            <b-form inline class="py-2">
              <label class="mr-2 col-3 text-right">Name:</label>
              <b-input
                size="sm"
                class="mr-1 inputsf"
                v-model="newMailTemplate.label"
                @input="computeOpenChanges()"
              />
            </b-form>

            <b-form inline class="py-2">
              <label class="mr-2 col-3 text-right">Absender:</label>
              <b-form-select
                v-model="newMailTemplate.mailAddressId"
                :options="mailTemplateAbsenderOptions"
                size="sm"
                @input="computeOpenChanges()"
              ></b-form-select>
            </b-form>

            <b-form inline class="py-2">
              <label class="mr-2 col-3 text-right">Betreff:</label>
              <b-input
                size="sm"
                class="mr-1 inputsf"
                v-model="newMailTemplate.mailSubject"
                @input="computeOpenChanges()"
              />
            </b-form>

            <b-form inline class="py-2">
              <label class="mr-2 col-3 text-right">Text:</label>
              <b-textarea
                rows="18"
                size="sm"
                class="mr-1 inputsf"
                v-model="newMailTemplate.mailText"
                @input="computeOpenChanges()"
              />
            </b-form>
            <b-form inline class="py-2">
              <label class="mr-02 col-3 text-right">Typ</label>
              <b-form-select
                v-model="newMailTemplate.mailTemplateType"
                :options="mailTemplateTypeOptions"
                size="sm"
                @input="computeOpenChanges()"
              ></b-form-select>
            </b-form>
            <b-form inline class="py-2">
              <label class="mr-02 col-3 text-right">Account</label>
              <b-form-select
                v-model="newMailTemplate.marketAccountId"
                :options="marketAccountOptions"
                size="sm"
                @input="computeOpenChanges()"
              ></b-form-select>
            </b-form>
          </form>

          <template #modal-footer>
            <div class="w-100">
              <b-button
                size="md"
                class="float-right mx-1"
                @click="save()"
              >
                speichern
              </b-button>
              <b-button
                size="md"
								variant="danger"
                class="float-right"
                @click="close()"
              >
                schließen
              </b-button>
            </div>
          </template>
        </b-modal>
      </b-card>
    </b-overlay>
  </div>
</template>
<style scoped>
.link2 {
  color: #131313 !important;
}
.link2:hover {
  color: #25bf43 !important;
  cursor: pointer;
}
.inputsf {
  min-width: 70% !important;
}
.modal-xl {
  max-width: auto !important;
  min-width: 92% !important;
}
.strikethrough {
  text-decoration: line-through;
  color: #ff8282;
}
.new-element {
  background-color: #d7ffdf;
}
</style>

<script>
export default {
  data() {
    return {
      queryInProgress: false,
      perPage: 1000,
      currentPage: 1,
      pageOptions: [25, 100, 250, 1000],
      modalCloseDialogueState: false,
      modalDeleteDialogueState: false,
      mailTemplateSelectedForDelete: null,
      newMailTemplate: null,
      openChanges: false,
      requestInProgress: false,
      modalSuccessDialogue: false, //TODO
      marketAccounts: [],
      mailTemplateShippers: [],
      items: [],
      mailTemplateMap: {
        1: "Bestellung",
        2: "Versenden",
        3: "Rückstellung",
        4: "Verzögerung 1",
        5: "Verzögerung 2",
        6: "Erinnerung",
        7: "Ersatzlieferung",
        8: "Trackinginfo",
      },
      fields: [
        {
          key: "label",
          label: "Name",
          sortable: true,
        },
        {
          key: "mailTemplateType",
          label: "Typ",
          sortable: true,
        },
        {
          key: "marketAccountId",
          label: "Account",
          sortable: true,
          formatter: (id) => {
            return this.marketAccounts.find((x) => x.id === id).name;
          },
        },
        {
          key: "mailAddressId",
          label: "Absender",
          sortable: true,
          formatter: (id) => {
            return this.mailTemplateShippers.find((x) => x.id === id)?.name;
          },
        },
        {
          key: "action",
          label: "",
          sortable: false,
        },
      ],
      modalEdit: {
        visible: false,
      },
    };
  },
  computed: {
    marketAccountOptions: function () {
      if (!this.marketAccounts) return [];
      return [
        { value: null, text: "-" },
        ...this.marketAccounts.map((x) => {
          return { value: x.id, text: x.name };
        }),
      ];
    },
    mailTemplateTypeOptions: function () {
      return Object.keys(this.mailTemplateMap).map((key) => {
        return { value: key, text: this.mailTemplateMap[key] };
      });
    },
    mailTemplateAbsenderOptions: function () {
      if (!this.mailTemplateShippers) return [];
      return [
        { value: null, text: "Bitte wähle den Absender aus" },
        ...this.mailTemplateShippers.map((x) => {
          return { value: x.id, text: x.email };
        }),
      ];
    },
  },
  methods: {
    createTemplate() {
      this.newMailTemplate = {
        charSet: null,
        id: null,
        label: null,
        mailSubject: null,
        mailTemplateType: null,
        mailText: null,
        marketAccountId: null,
        mailAddressId: null,
      };
      this.modalEdit.oldMailTemplate = _.cloneDeep(this.newMailTemplate);
      this.modalEdit.visible = true;
    },
    computeOpenChanges() {
      this.openChanges = false;
      // if success dialogue is being visiblen, we just updated the address and there are no pending changes.
      if (this.modalSuccessDialogue) {
        return;
      }
      if (!this.modalEdit.oldMailTemplate || !this.newMailTemplate) {
        return;
      }

      for (let key of Object.keys(this.modalEdit.oldMailTemplate)) {
        if (
          (this.modalEdit.oldMailTemplate[key]
            ? this.modalEdit.oldMailTemplate[key]
            : "") !==
          (this.newMailTemplate[key] ? this.newMailTemplate[key] : "")
        ) {
          this.openChanges = true;
          break;
        }
      }
    },
    edit(id) {
      let maybeMailTemplate = this.items.find((x) => x.id === id);
      if (!maybeMailTemplate) {
        alert(
          "Fehler: konnte Mail Template nicht finden für MailTemplateId: " + id,
        );
        return;
      }
      this.modalEdit.oldMailTemplate = maybeMailTemplate;
      this.newMailTemplate = _.cloneDeep(maybeMailTemplate);
      this.modalEdit.visible = true;
    },
    save() {
      if (!this.modalEdit.visible) {
        alert("not currently displaying modal");
        return;
      }
      if (!this.newMailTemplate.mailTemplateType) {
        alert("Typ muss angegeben werden!");
        return;
      }
      if (!this.newMailTemplate.marketAccountId) {
        alert("Account muss angegeben werden!");
        return;
      }
      if (!this.newMailTemplate.label) {
        alert("Name muss angegeben werden!");
        return;
      }
      if (!this.newMailTemplate.mailSubject) {
        alert("Betreff muss angegeben werden!");
        return;
      }
      if (!this.newMailTemplate.mailAddressId) {
        alert("Absender muss angegeben werden!");
        return;
      }

      this.requestInProgress = true;

      axios
        .post("/mailtemplate/save", this.newMailTemplate)
        .then((response) => {
          this.requestInProgress = false;
          if (this.newMailTemplate.id) {
            for (let k = 0; k < this.items.length; ++k) {
              if (this.items[k].id == this.newMailTemplate.id) {
                this.items[k] = _.cloneDeep(this.newMailTemplate);
                break;
              }
            }
            // this.items.find( mt => mt.id === this.newMailTemplate.id ) = _.cloneDeep(this.newMailTemplate);
          } else {
            this.newMailTemplate.id = response.data.id;
            this.newMailTemplate.isCreated = true;
            this.items.unshift(_.cloneDeep(this.newMailTemplate));
          }
          this.newMailTemplate = null;
          this.modalSuccessDialogue = true;
        })
        .catch((error) => {
          this.requestInProgress = false;
          alert("Fehler beim Speichern.");
          console.error(error);
        });
    },
    remove() {
      if (!this.mailTemplateSelectedForDelete) {
        alert("no mailTemplate selected!");
        return;
      }
      this.queryInProgress = true;
      Promise.all([
        axios.get(
          `/mailtemplate/delete/${this.mailTemplateSelectedForDelete.id}`,
        ),
        new Promise((r) => setTimeout(r, 750)),
      ])
        .then(([response]) => {
          this.items.splice(
            this.items.indexOf(this.mailTemplateSelectedForDelete),
            1,
          );
          this.items.unshift(this.mailTemplateSelectedForDelete);
          this.mailTemplateSelectedForDelete.isDeleted = true;
          if ("isCreated" in this.mailTemplateSelectedForDelete)
            delete this.mailTemplateSelectedForDelete.isCreated;
          this.queryInProgress = false;
          this.modalDeleteDialogueState = false;
          this.$forceUpdate();
        })
        .catch((error) => {
          alert("something went wrong.");
          this.queryInProgress = false;
        });
    },
    close() {
      if (this.openChanges) {
        this.modalCloseDialogueState = true;
      } else {
        this.modalEdit.visible = false;
        this.newMailTemplate = null;
        this.modalEdit.oldMailTemplate = null;
        this.openChanges = false;
      }
    },
    modalCloseDialogue(choice) {
      if ("confirm" === choice) {
        this.newMailTemplate = null;
        this.openChanges = false;
        this.modalEdit.oldMailTemplate = null;
        this.modalEdit.visible = false;
      } else if ("abort" == choice) {
        //do nothing
      }

      this.modalCloseDialogueState = false;
    },
    openDeleteDialogue(mailTemplate) {
      this.mailTemplateSelectedForDelete = mailTemplate;
      this.modalDeleteDialogueState = true;
    },
    getTypeLabel(mailTemplateTypeId) {
      return this.mailTemplateMap[mailTemplateTypeId];
    },
  },
  beforeCreate() {
    this.requestInProgress = true;

    Promise.all([
      axios.get("/marketaccount/all"),
      axios.get("mailtemplate/all"),
      axios.get("mail_address/all"),
    ])
      .then(
        ([
          responseMarketAccount,
          responseMailTemplate,
          responseMail_Address,
        ]) => {
          this.requestInProgress = false;
          this.items = responseMailTemplate.data; //.map( x => { x.action = "" ; return x});
          this.marketAccounts = responseMarketAccount.data;
          this.mailTemplateShippers = responseMail_Address.data;
        },
      )
      .catch((error) => {
        this.requestInProgress = false;
        alert("Konnte Daten nicht anfordern.");
        console.error(error);
      });
  },
  created() {},
};
</script>
